import { Card, CardContent, CardHeader, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ApiManagement from "../account-settings/api-management/ApiManagement";

export default function UserApiCard() {

    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2),
                height: '100%'
            }}
        >
            <CardHeader
                sx={{
                    padding: 1
                }}
                title={t('profile.api')}
                slotProps={{
                    title: {
                        sx: { 
                            fontWeight: "bold", 
                        },
                        variant: 'subtitle1', 
                    }
                }}
            />
            
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <ApiManagement visible={true} />

            </CardContent>
        </Card>
    );
}